declare global {
  interface Window {
    Intercom: any
    intercomSettings: any
  }
}

// Add IntercomFunction type definition
interface IntercomFunction extends Function {
  c?: (args: any) => void
  q?: any[]
}

const loadIntercomScript = () => {
  return new Promise<void>((resolve) => {
    if (typeof window === 'undefined') return resolve()

    if (window.Intercom) {
      return resolve()
    }

    // Add Intercom's script
    const script = document.createElement('script')
    script.src = 'https://widget.intercom.io/widget/ftpz983z'
    script.async = true

    script.onload = () => {
      // Initialize Intercom with proper typing
      ;(function () {
        var w = window
        var ic = w.Intercom
        if (typeof ic === 'function') {
          ic('reattach_activator')
          ic('update', w.intercomSettings)
        } else {
          var d = document
          var i = function (this: IntercomFunction) {
            i.c?.call(this, arguments)
          } as IntercomFunction
          i.q = []
          i.c = function (args: IArguments) {
            i.q?.push(args)
          }
          w.Intercom = i
        }
      })()
      resolve()
    }

    document.body.appendChild(script)
  })
}

export const initIntercom = async (userConfig?: {
  userId?: string
  name?: string
  email?: string
  createdAt?: number
}) => {
  if (typeof window === 'undefined') return

  await loadIntercomScript()

  window.Intercom('boot', {
    api_base: 'https://api-iam.intercom.io',
    app_id: 'ftpz983z',
    ...(userConfig && {
      user_id: userConfig.userId,
      name: userConfig.name,
      email: userConfig.email,
      created_at: userConfig.createdAt,
    }),
  })
}

export const updateIntercom = async (userConfig: {
  userId?: string
  name?: string
  email?: string
  createdAt?: number
}) => {
  if (typeof window === 'undefined') return

  await loadIntercomScript()

  window.Intercom('update', {
    ...userConfig,
  })
}
